export enum UserType {
    NONE,
    RA,
    RI,
    ERCS,
}
